import { VApp } from 'vuetify/lib/components/VApp';
import { VMain } from 'vuetify/lib/components/VMain';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VApp,[_c('layout-navbar'),_c('layout-sidenav'),_c(VMain,{staticClass:"fixed-padding",style:(_vm.isCustomDashboard ? 'background-color: #f6f5f5' : 'background-color: white')},[_c('router-view'),_c('alert-component',{attrs:{"data":_vm.nomenclatorAlert}})],1),_c('DataWS',{attrs:{"userid":(_vm.profile.id).toString()}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }